(function () {
  function linkFairlandReference() {
    if (!/\/products\//.test(window.location.pathname)) return;

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!/fairland\.com\.cn/i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;

        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest("a, script, style, textarea, input")) return NodeFilter.FILTER_REJECT;

        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var fragment = document.createDocumentFragment();
      var parts = textNode.nodeValue.split(/(fairland\.com\.cn)/i);

      parts.forEach(function (part) {
        if (/^fairland\.com\.cn$/i.test(part)) {
          var link = document.createElement("a");
          link.href = "https://fairland.com.cn";
          link.target = "_blank";
          link.rel = "noopener";
          link.style.color = "#25AAE1";
          link.style.textDecoration = "underline";
          link.textContent = part;
          fragment.appendChild(link);
        } else if (part) {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function refreshDolphinRequestCopy() {
    if (!document.documentElement.classList.contains("psh-hide-sale-price")) return;

    document.querySelectorAll("sticky-add-to-cart, .sticky-add-to-cart, .sticky-add-to-cart__bar, .add-to-cart-button").forEach(function (element) {
      element.style.setProperty("display", "none", "important");
    });
    document.querySelectorAll("quick-add-component, .buy-buttons-block, .product-form-buttons, .product-card__link-button--special").forEach(function (element) {
      element.style.setProperty("display", "none", "important");
    });

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (/^\s*trueyes\s*$/i.test(node.nodeValue)) {
        node.nodeValue = "";
      }
    }

    var isX25 = /dolphin-x25/i.test(window.location.pathname);
    if (isX25) {
      document.querySelectorAll("p").forEach(function (paragraph) {
        if (!/Click\s+Get My Best Price Now/i.test(paragraph.textContent)) return;
        if (paragraph.querySelector("[data-psh-modal-target]")) return;

        var target = Array.from(paragraph.querySelectorAll("strong, b, span, a")).find(function (element) {
          return /Get My Best Price Now/i.test(element.textContent);
        });
        if (!target) return;

        var trigger = document.createElement("a");
        trigger.href = "#psh-dolphin-request";
        trigger.setAttribute("role", "button");
        trigger.className = "psh-request-trigger psh-inline-request-button";
        trigger.setAttribute("data-psh-modal-target", "psh-dolphin-request");
        trigger.textContent = "Get My Best Price Now";
        target.replaceWith(trigger);
      });
    }

    var policy = document.querySelector(".psh-product-policy--dolphin");
    if (!policy) return;

    var heading = policy.querySelector("h3");
    if (heading && isX25) heading.textContent = "Get your Dolphin X25 offer";

    var badge = policy.querySelector(".psh-badge");
    if (badge && isX25) badge.textContent = "Up to $500 off RRP";

    var trigger = policy.querySelector(".psh-request-trigger");
    if (trigger) trigger.textContent = "Get My Best Price Now";

    if (!policy.querySelector(".psh-stock-note")) {
      var stock = document.createElement("div");
      stock.className = "psh-stock-note";
      stock.textContent = "In stock at Pool Supply Hub";
      if (trigger) {
        policy.insertBefore(stock, trigger);
      } else {
        policy.appendChild(stock);
      }
    }

    var modalTitle = document.querySelector("#psh-dolphin-request #psh-request-title");
    if (modalTitle) modalTitle.textContent = "Get your best Dolphin price";
  }

  function refreshAstralRequestLinks() {
    var astralModal = document.getElementById("psh-astral-request");
    if (!astralModal) return;

    document.querySelectorAll('a[href="#psh-dolphin-request"], [data-psh-modal-target="psh-dolphin-request"]').forEach(function (link) {
      var productCard = link.closest("product-card");
      var contextText = ((productCard && productCard.textContent) || "") + " " + link.textContent;
      if (!/Astral\s*CTX\s*280|CTX\s*280/i.test(contextText)) return;

      if (productCard) {
        productCard.classList.remove("psh-hidden-price-card", "psh-dolphin-price-card");
        productCard.classList.add("psh-astral-request-card");
      }

      link.href = "#psh-astral-request";
      link.setAttribute("data-psh-modal-target", "psh-astral-request");
      link.classList.add("psh-astral-request-button");
      link.setAttribute("data-psh-product-title", "Astral CTX280");

      var label = link.querySelector(".add-to-cart-text__content");
      if (label) {
        label.textContent = "Request to Buy";
      } else {
        link.textContent = "Request to Buy";
      }
    });
  }

  function resizeAstralRequestButtons() {
    document.querySelectorAll('[data-psh-modal-target="psh-astral-request"].quick-add__button.external_cta_text, [data-psh-modal-target="psh-zodiac-request"].quick-add__button.external_cta_text').forEach(function (button) {
      button.style.setProperty("--button-background-color", "#0f4c81", "important");
      button.style.setProperty("--button-border-color", "#0f4c81", "important");
      button.style.setProperty("--button-color", "#ffffff", "important");
      button.style.setProperty("width", "auto", "important");
      button.style.setProperty("min-width", window.innerWidth < 750 ? "150px" : "168px", "important");
      button.style.setProperty("min-height", window.innerWidth < 750 ? "40px" : "42px", "important");
      button.style.setProperty("padding", window.innerWidth < 750 ? "8px 14px" : "9px 18px", "important");
      button.style.setProperty("border-radius", "8px", "important");
      button.style.setProperty("gap", "8px", "important");
      button.style.setProperty("font-size", window.innerWidth < 750 ? "0.9rem" : "0.95rem", "important");
      button.style.setProperty("font-weight", "700", "important");
      button.style.setProperty("line-height", "1.15", "important");

      var icon = button.querySelector(".add-to-cart-icon");
      if (icon) {
        icon.style.setProperty("width", "16px", "important");
        icon.style.setProperty("height", "16px", "important");
        icon.style.setProperty("flex", "0 0 16px", "important");
      }
    });
  }

  function removeZodiacInstallationFields() {
    var modal = document.getElementById("psh-zodiac-request");
    if (!modal) return;
    modal.querySelectorAll(".psh-install-option, .psh-install-fields").forEach(function (element) {
      element.remove();
    });
  }

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.hidden = false;
    var input = modal.querySelector('input[type="email"]');
    if (input) input.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
  }

  function syncInstallationFields(toggle) {
    var modal = toggle.closest(".psh-request-modal");
    if (!modal) return;
    var fields = modal.querySelector(".psh-install-fields");
    if (!fields) return;

    fields.hidden = !toggle.checked;
    fields.querySelectorAll("[data-psh-install-required]").forEach(function (input) {
      input.required = toggle.checked;
      if (!toggle.checked) input.value = "";
    });

    if (toggle.checked) {
      var first = fields.querySelector("input");
      if (first) first.focus();
    }
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-psh-modal-target]");
    if (trigger) {
      event.preventDefault();
      var modal = document.getElementById(trigger.getAttribute("data-psh-modal-target"));
      var productTitle = trigger.getAttribute("data-psh-product-title");
      if (modal && productTitle) {
        var productField = modal.querySelector('[data-psh-request-product-field]');
        if (productField) productField.value = productTitle;
      }
      openModal(trigger.getAttribute("data-psh-modal-target"));
      return;
    }

    var close = event.target.closest("[data-psh-modal-close]");
    if (close) {
      closeModal(close.closest(".psh-request-modal"));
    }
  });

  document.addEventListener("change", function (event) {
    var toggle = event.target.closest("[data-psh-install-toggle]");
    if (!toggle) return;
    syncInstallationFields(toggle);
  });

  document.querySelectorAll("[data-psh-install-toggle]").forEach(syncInstallationFields);

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".psh-request-modal:not([hidden])").forEach(closeModal);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      linkFairlandReference();
      refreshDolphinRequestCopy();
      refreshAstralRequestLinks();
      removeZodiacInstallationFields();
      resizeAstralRequestButtons();
    });
  } else {
    linkFairlandReference();
    refreshDolphinRequestCopy();
    refreshAstralRequestLinks();
    removeZodiacInstallationFields();
    resizeAstralRequestButtons();
  }

  window.addEventListener("resize", resizeAstralRequestButtons);
  new MutationObserver(function () {
    refreshAstralRequestLinks();
    removeZodiacInstallationFields();
    resizeAstralRequestButtons();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
